import { render } from "./ModulesEducationView.vue?vue&type=template&id=39a9bdc7"
import script from "./ModulesEducationView.vue?vue&type=script&lang=js"
export * from "./ModulesEducationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__